import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalTerminateModal extends React.Component {
  render() {
    const {
      show,
      rental,
      isLoading,
      onClose,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = rental.product ? rental.product.designation : "Produit";
    const establishmentName = rental.establishment
      ? rental.establishment.name
      : "Établissement";

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-terminate-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header className="rental-delete-modal-header">
          <Modal.Title className="rental-modal-title">
            Terminer la location
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Terminer la location
            </h5>
            <p className="rental-modal-form-hint">
              Terminaison de la location pour <strong>{productName}</strong> à{" "}
              <strong>{establishmentName}</strong>
            </p>
            <p className="rental-modal-form-hint">
              Cette action va créer une demande de récupération pour l'équipement associé.
            </p>
            <p className="rental-modal-form-hint mt-3">
              <strong>Êtes-vous sûr de vouloir terminer cette location ?</strong>
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="btn btn-secondary"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="btn btn-danger"
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span> Terminaison...</span>
              </>
            ) : (
              "Terminer"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalTerminateModal;
